import { MonoBehavior } from 'game/core/monoBehavior';
import { getIcon } from 'game/preloadGameAssets';
import { theme } from 'game/theme';
import { Container, Text, Graphics } from 'pixi.js';
import { Layout } from 'game/LayoutManager';
import { addHoverEffect } from './hover';
import { Store } from 'game/store/gameStore';
import gsap from 'gsap';
import { EventName } from 'game/events/eventsName';
import { GameEvent } from 'game/events/gameEvent';

export class CircleButton extends MonoBehavior {
    public container: Container;
    public contentContainer: Container;
    public fadeContainer: Container;
    public withBG: boolean;
    private disabled = false;
    cb?: () => void;
    notification?: Graphics;
    label?: Text;
    badge?: Graphics;
    constructor(public iconName: string, withBG: boolean) {
        super();
        this.iconName = iconName;
        this.setDisabled = this.setDisabled.bind(this);
        this.container = new Container();
        this.contentContainer = new Container();
        this.fadeContainer = new Container();
        this.contentContainer.sortableChildren = true;

        this.container.position.x = -9999999;
        this.container.zIndex = 1000;
        this.withBG = withBG;
        this.container.sortableChildren = true;
        this.contentContainer.on('pointerdown', this.triggerClick.bind(this));
        this.fadeContainer.addChild(this.contentContainer);
        if (Store.hasNotification(iconName)) {
            this.addNotification();
        }
        addHoverEffect(this.contentContainer);
        GameEvent.add(EventName.FADE_UI, this.fadeUI.bind(this));
        GameEvent.add(EventName.GAME_READY, this.addToUI.bind(this));
    }
    fadeUI({ alpha, duration }: { alpha: number; duration: number }) {
        gsap.to(this.fadeContainer, { alpha, duration });
    }
    addToUI() {
        this.container.addChild(this.fadeContainer);
    }
    addNotification() {
        this.removeNotification();
        this.notification = new Graphics();
        this.notification.circle(0, 0, 6);
        this.notification.fill(0xf13b3b);
        this.fadeContainer.addChild(this.notification);
        this.notification.zIndex = 10;
        this.notification.position.set(Layout.getButtonSize() * 0.37, -Layout.getButtonSize() * 0.37);
    }
    addLabel(text: string | number) {
        if (!this.badge) this.badge = new Graphics();
        this.badge.clear();
        this.badge.circle(0, 0, 10);
        this.badge.fill(0x149246);
        this.fadeContainer.addChild(this.badge);
        this.badge.zIndex = 10;
        this.badge.position.set(Layout.getButtonSize() * 0.37, -Layout.getButtonSize() * 0.37);

        if (this.label) this.label.destroy();
        this.label = new Text({
            text,
            style: {
                textBaseline: 'middle', //
                fontFamily: 'Inter',
                fill: '#ffffff',
                fontSize: 12,
                lineHeight: 20,
            },
        });
        this.label.anchor.set(0.5);
        this.label.position.set(Layout.getButtonSize() * 0.37, -Layout.getButtonSize() * 0.37 - 4);
        this.fadeContainer.addChild(this.label);
        this.label.zIndex = 12;
    }
    setDisabled(disabled: boolean): void {
        this.disabled = disabled;
        this.contentContainer.eventMode = disabled ? 'none' : 'static';
        this.contentContainer.alpha = disabled ? 0.5 : 1;
        // this.contentContainer.alpha = 1;
        this.container.cursor = disabled ? 'inherit' : 'pointer';
        if (this.notification) this.notification.visible = !disabled;
    }
    triggerClick() {
        if (this.disabled) return;
        Store.removeNotification(this.iconName);
        this.removeNotification();

        this.cb?.();
    }
    removeNotification() {
        if (this.notification) {
            this.notification.removeFromParent();
            this.notification.destroy();
            this.notification = undefined;
        }
    }
    onClick(cb: () => void) {
        this.cb = cb;
    }
    async drawButton() {
        const bg = new Graphics();
        bg.circle(0, 0, 29);
        bg.fill(theme.buttonBackground);
        bg.alpha = 0;
        if (this.withBG) {
            bg.alpha = 0.3;
        }
        this.contentContainer.addChild(bg);
        const icon = await getIcon(`buttons/${this.iconName}`, true);

        this.contentContainer.addChild(icon);

        this.resize();
        setTimeout(this.resize, 1000);
    }

    start(): void {
        this.drawButton();
        this.contentContainer.cursor = 'pointer';
    }
    resize(): void {
        this.contentContainer.width = Layout.getButtonSize();
        this.contentContainer.height = Layout.getButtonSize();
        if (this.notification) {
            this.notification.position.set(Layout.getButtonSize() * 0.37, -Layout.getButtonSize() * 0.37);
        }
    }
}
